import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Sort } from "@evergis/ui";

import { getTableSort } from "../../../ducks/table/selectors";
import { updateTableSort } from "../../../ducks/table/table";

export const useTableSort = (): [Record<string, Sort>, (value: Record<string, Sort>) => void] => {
  const dispatch = useDispatch();
  const tableSort = useSelector(getTableSort);

  const setTableSort = useCallback(
    (value: Record<string, Sort>) => {
      dispatch(updateTableSort(value));
    },
    [dispatch],
  );

  return [tableSort, setTableSort];
};
